import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '../../icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  selector: 'ui-action-card-icon',
  template: `
    <div class="{{ 'flex justify-center items-center p-2.5 text-xl rounded-lg h-11 aspect-square ' + class() }}">
      <ui-icon [icon]="icon()!" class="text-2xl" />
    </div>
  `,
})
export class ActionCardIconComponent {
  icon = input<string>();
  class = input<string>();
}
